---
title: Plan, extras y facturas
parent: Documentación
parentHref: /docs
---

<script>
  import DomainTlds from "@/components/domain-tlds.svelte"
</script>

# Plan, extras, facturas y páginas legales

## Un plan con todo incluido

TOBY tiene un plan completo sin tarifa de instalación y sin niveles ocultos:

- **Facturación mensual o anual:** Elija entre facturación mensual flexible (cancelable mensualmente en cualquier momento) o facturación anual con descuento (también pagadera mediante factura). Consulte la [lista de precios](/es/pricing) para ver los precios actuales.

Cada suscripción incluye:

- **Su propio dominio** (<DomainTlds />) — incluyendo la transferencia de un dominio existente (Domain-Umzug)
- **1 dirección de correo electrónico** (info@...) con un **buzón de 15 GB (Maxi-Postfach)** y direcciones de reenvío ilimitadas
- **Hasta 15 páginas** — creadas y mantenidas por chat, voz o carga de fotos
- **1 idioma adicional** (2 idiomas en total) con traducción automática al publicar
- **Boletín informativo** con **1.000 correos electrónicos / mes**
- **Análisis de visitantes** (respetuoso con la privacidad, sin banners de cookies)
- **Paquete inicial por correo** (pegatina para puerta y soporte de mesa QR A5)
- **Alojamiento en la UE** con seguridad SSL automática

## Extras opcionales

Si su negocio crece más allá de los límites incluidos, puede agregar bloques flexibles en cualquier momento en **Ajustes → Suscripción** (cancelables mensualmente, consulte la [lista de precios](/es/pricing)):

- **+15 GB de almacenamiento de correo electrónico** (o un buzón adicional)
- **+1 idioma adicional para el sitio web**
- **+15 páginas adicionales**
- **+5.000 correos electrónicos de boletín / mes**

## Obtener una factura comercial adecuada (Sitio web vs. Google Play)

Si gestiona una empresa, consultorio o cuenta de autónomo y necesita una **factura comercial deducible de impuestos adecuada (ordentliche Rechnung)** con el nombre de su empresa, dirección comercial e IVA (MwSt.) mostrado por separado, tenga en cuenta dónde se suscribe:

- **Suscripción en el sitio web (tobysite.com a través de Stripe):** Siempre recibe una **factura comercial adecuada con IVA** de nuestra parte, dirigida a su empresa. Puede descargar todas las facturas anteriores y actualizar la dirección de facturación de su empresa en cualquier momento en **Ajustes → Suscripción**.
- **Suscripción en la aplicación de Android (compra dentro de la aplicación de Google Play):** Cuando se suscribe a través de Google Play, Google procesa el pago como comerciante registrado y solo emite un recibo de pago estándar de Google Play. **No podemos emitir una factura comercial con IVA (ordentliche Rechnung) para suscripciones facturadas a través de Google Play.**

> **Consejo:** Puede suscribirse en **tobysite.com** en su navegador para obtener facturas comerciales adecuadas de Stripe y seguir usando las aplicaciones de TOBY para Android e iOS con su cuenta sin costo adicional.

## Agregar su Aviso Legal (Impressum) y Política de Privacidad (Datenschutz)

- **Su propio texto legal:** Debido a que los requisitos legales dependen de la estructura de su negocio, profesión y país, **TOBY no genera asesoramiento legal ni redacta textos legales (Impressum o Datenschutzerklärung) por sí solo.**
- **Cómo agregarlos:** Simplemente pegue el texto de su Aviso Legal o Política de Privacidad existente en el chat (o súbalo como documento Word/PDF, o pida a TOBY que lo copie de su antiguo sitio web) y diga *"Pon esto en nuestra página de Aviso Legal."* TOBY creará las páginas y las enlazará de forma ordenada en el pie de página de su sitio web.
